import { createEntityAdapter } from '@reduxjs/toolkit';
import { IAddress } from './addressesInterfaces';

export const addressesEntityAdapter = createEntityAdapter<IAddress>({ selectId: x => x.addressId });
